import { Component, computed, input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl, Patient, PipesModule } from '@xmedical/core';

@Component({
  selector: 'xmed-patient-summary-renderer',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    PipesModule
  ],
  templateUrl: './patient-summary-renderer.component.html',
  styleUrl: './patient-summary-renderer.component.scss'
})
export class PatientSummaryRendererComponent {
  control = input.required<ReportControl>();

  readonly patient = computed<Patient>(() => this.control().patientValue);

  get treatingDoctorName(): string {
    return 'Dr Test';
  }
}
